import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const CaretRightIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 8 12" },
        React.createElement("path", { d: "M2.41392 0.646521L7.41384 5.64644C7.6091 5.8417 7.6091 6.15828 7.41384 6.35355L2.41392 11.3535C2.21866 11.5487 1.90208 11.5487 1.70681 11.3535L0.999847 10.6465C0.804587 10.4513 0.804587 10.1347 0.999847 9.9394L4.93927 5.99998L0.999847 2.06056C0.804587 1.8653 0.804587 1.54872 0.999847 1.35345L1.70681 0.646491C1.90207 0.451231 2.21865 0.451261 2.41392 0.646521Z" })));
};

export { CaretRightIcon };
//# sourceMappingURL=CaretRightIcon.esm.js.map
